import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
const CreatePostIndex = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`${ROUTE_KEYS.CREATE_POST}/${ROUTE_KEYS.CREATE_POST_DETAILS}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default CreatePostIndex;
